import { render, staticRenderFns } from "./NewKeeBreadcrumb.vue?vue&type=template&id=2b36fa1e"
import script from "./NewKeeBreadcrumb.vue?vue&type=script&lang=js"
export * from "./NewKeeBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./NewKeeBreadcrumb.vue?vue&type=style&index=0&id=2b36fa1e&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b36fa1e')) {
      api.createRecord('2b36fa1e', component.options)
    } else {
      api.reload('2b36fa1e', component.options)
    }
    module.hot.accept("./NewKeeBreadcrumb.vue?vue&type=template&id=2b36fa1e", function () {
      api.rerender('2b36fa1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/keeCourses/NewKeeBreadcrumb.vue"
export default component.exports